import { toast } from 'react-toastify';

export const successToast = (message = 'Wow so easy!') => {
  toast.success(message, {
    position: 'bottom-left',
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  });
};
export const errorToast = (message = 'Something wrong') => {
  toast.error(message, {
    position: 'bottom-left',
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  });
};
